(function ($) {
  var body = $("body"),
    doc = $(document),
    html = $("html"),
    win = $(window);
  var $body = $('body'),
        $doc = $(document),
        $html = $('html'),
        $win = $(window);
  
  var winWidth = win.innerWidth();
  
  doc.ready(function () {
    doc.ajaxStart(function () {
      valfre.isAjaxLoading = true;
    });

    doc.ajaxStop(function () {
      valfre.isAjaxLoading = false;
    });

    valfre.init();
  });
  var valfre = {
    valfreTimeout: null,
    isAjaxLoading: false,
    init: function () {
      console.log('valfre init');
      if(body.hasClass('template-collection')) {
        this.initInfiniteScrolling();
      }
      if(body.hasClass('template-blog')) {
        this.initBlogInfiniteScrolling();
      }
      if(body.hasClass('valfre--pages-works')) {
        this.initWorksFiltersPopup();
      }
      if(body.hasClass('valfre-pages-works')) {
        this.initWorksDetailsPopup();
        this.initInquireDetailsPopup();
      }
      if(body.hasClass('template-artwork')) {
        this.initInquireDetailsPopup();
      }
      if(body.hasClass('template-product')) {
        this.setImageContainerPosition();
      }
    },
    showLoading: function () {
      $('.loading-modal').show();
    },

    hideLoading: function () {
      $('.loading-modal').hide();
    },

    initInfiniteScrolling: function(){
        if ($('.pagination-infinite'.length > 0)) {
            $win.on('scroll load', () => {
                var currentScroll = $win.scrollTop(),
                    pageInfinite = $('.pagination-infinite'),
                    linkInfinite = pageInfinite.find('[data-infinite-scrolling]'),
                    position; 

                if(linkInfinite.length > 0 && !linkInfinite.hasClass('is-loading')){
                    position = pageInfinite.offset().top - 1000;
                    console.log(currentScroll, position);
                    if (currentScroll > position) {
                        var url = linkInfinite.attr('href');

                        valfre.doAjaxInfiniteScrollingGetContent(url, linkInfinite);
                    }
                }
            });
        }

        $doc.on('click', '[data-infinite-scrolling]', (event) => {
            var linkInfinite = $(event.currentTarget),
                url = linkInfinite.attr('href');

            event.preventDefault();
            event.stopPropagation();

            valfre.doAjaxInfiniteScrollingGetContent(url, linkInfinite);
        });
    },

    doAjaxInfiniteScrollingGetContent: function(url, link){
        $.ajax({
            type: 'GET',
            url: url,
            beforeSend: function () {
                //link.text(link.attr('data-loading-more'));
                link.addClass('is-loading');
            },
            success: function (data) {
                valfre.ajaxInfiniteScrollingMapData(data);
            },
            error: function (xhr, text) {
                alert($.parseJSON(xhr.responseText).description);
            },
            complete: function () {
                //link.text(link.attr('data-load-more'));
                link.removeClass('is-loading');
            }
        });
    },

    ajaxInfiniteScrollingMapData: function(data){
        var currentTemplate = $('#ProductGridContainer'),
            currentProductListing = currentTemplate.find('.productListing'),
            currentPagination = currentTemplate.find('.pagination-infinite'),
            newTemplate = $(data).find('#ProductGridContainer'),
            newProductListing = newTemplate.find('.productListing'),
            newPagination = newTemplate.find('.pagination-infinite'),
            newProductItem = newProductListing.children('.product__item');
            currentPagination.replaceWith(newPagination);
        if (newProductItem.length > 0) {
            currentProductListing.append(newProductItem);
        }
    },


    initBlogInfiniteScrolling: function(){
        if ($('.pagination-infinite'.length > 0)) {
            $win.on('scroll load', () => {
                var currentScroll = $win.scrollTop(),
                    pageInfinite = $('.pagination-infinite'),
                    linkInfinite = pageInfinite.find('[data-infinite-scrolling]'),
                    position; 

                if(linkInfinite.length > 0 && !linkInfinite.hasClass('is-loading')){
                    position = pageInfinite.offset().top - 1000;
                    console.log(currentScroll, position);
                    if (currentScroll > position) {
                        var url = linkInfinite.attr('href');

                        valfre.doBlogAjaxInfiniteScrollingGetContent(url, linkInfinite);
                    }
                }
            });
        }

        $doc.on('click', '[data-infinite-scrolling]', (event) => {
            var linkInfinite = $(event.currentTarget),
                url = linkInfinite.attr('href');

            event.preventDefault();
            event.stopPropagation();

            valfre.doBlogAjaxInfiniteScrollingGetContent(url, linkInfinite);
        });
    },

    doBlogAjaxInfiniteScrollingGetContent: function(url, link){
        $.ajax({
            type: 'GET',
            url: url,
            beforeSend: function () {
                //link.text(link.attr('data-loading-more'));
                link.addClass('is-loading');
            },
            success: function (data) {
                valfre.ajaxBlogInfiniteScrollingMapData(data);
            },
            error: function (xhr, text) {
                alert($.parseJSON(xhr.responseText).description);
            },
            complete: function () {
                //link.text(link.attr('data-load-more'));
                link.removeClass('is-loading');
            }
        });
    },

    ajaxBlogInfiniteScrollingMapData: function(data){
        var currentTemplate = $('#main-blog-container'),
            currentProductListing = currentTemplate.find('.blog-articles'),
            currentPagination = currentTemplate.find('.pagination-infinite'),
            newTemplate = $(data).find('#main-blog-container'),
            newProductListing = newTemplate.find('.blog-articles'),
            newPagination = newTemplate.find('.pagination-infinite'),
            newProductItem = newProductListing.children('.blog-articles__article');
            currentPagination.replaceWith(newPagination);
        if (newProductItem.length > 0) {
            currentProductListing.append(newProductItem);
        }
    },
    
    initWorksFiltersPopup: function () {
      var openCTASlt = '.open-wc-filters';
      var closeCTASlt = '.close-wc-filters';
      var workFilterBlockSlt = '.work-filters-list';
      body.off('click.initWorksFiltersPopup', openCTASlt).on('click.initWorksFiltersPopup', openCTASlt, function (e) {
        e.preventDefault();
        e.stopPropagation();
        this.parentNode.classList.add('active')
        this.parentNode.querySelector(workFilterBlockSlt).classList.add('show');
        this.setAttribute('aria-expanded', 'true');
        this.parentNode.querySelector('.close-wc-filters').focus();
      });
      body.off('click.initWorksFiltersPopup', closeCTASlt).on('click.initWorksFiltersPopup', closeCTASlt, function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeFilters();
      });

      function closeFilters() {
        $(workFilterBlockSlt).removeClass('show');
        $(openCTASlt).attr('aria-expanded', 'false').trigger('focus');
      }
      $(document).on('keydown.worksFilters', function(e) {
        if (e.key === 'Escape' && $(workFilterBlockSlt).hasClass('show')) closeFilters();
      });
      $(document).on('click', '.apply-filters', function(e) {
          e.preventDefault();
          var activeFilters = $('.work-filter-checkbox:checked').map(function() { return this.value; }).get();
          $('.wc-default').each(function() {
            this.hidden = activeFilters.length > 0 && !activeFilters.includes(this.dataset.workCategory);
          });
          closeFilters();
      });
      $(document).on('click', '.clear-filters', function(e) {
          e.preventDefault();
          $('.wc-default').prop('hidden', false);
          $('.work-filter-checkbox').prop('checked', false);
          closeFilters();
      });
    },

    initWorksDetailsPopup: function () {
      var workCTASlt = '.work-card-outer-img-wrapper';
      var workCloseSlt = '.close-details-popup';
      body.off('click.initWorksDetailsPopup', workCTASlt).on('click.initWorksDetailsPopup', workCTASlt, function (e) {
        e.preventDefault();
        e.stopPropagation();
        this.parentNode.querySelector('.work-card-details-wrapper').classList.add('active')
      });
      body.off('click.initWorksDetailsPopup', workCloseSlt).on('click.initWorksDetailsPopup', workCloseSlt, function (e) {
        e.preventDefault();
        e.stopPropagation();
        this.parentNode.parentNode.classList.remove('active')
      });      
    },

    initInquireDetailsPopup: function () {
      var inquireCTASlt = '.card-inquire-cta';
      var inquireCloseSlt = '.close-inquire-popup';

      body.off('click.initInquireDetailsPopup', inquireCTASlt).on('click.initInquireDetailsPopup', inquireCTASlt, function (e) {
        e.preventDefault();
        e.stopPropagation();
        this.parentNode.querySelector('.inquire--contact-form--wrapper').classList.add('show')
      });
      body.off('click.initInquireDetailsPopup', inquireCloseSlt).on('click.initInquireDetailsPopup', inquireCloseSlt, function (e) {
        e.preventDefault();
        e.stopPropagation();
        document.querySelector('.inquire--contact-form--wrapper').classList.remove('show')
      });
      
    },

    setImageContainerPosition: function() {
      var dotsBlockHeight = $('.product-image__dots-container').height();
      $('.product__images-wrapper').css('margin-top', `-${dotsBlockHeight}px`);
    }
  }
})(jQuery);
